import { useMemo } from 'react';

import { Allergens } from 'components/nutrition/allergens';
import { TableHeader } from 'components/nutrition/v2/table-header';
import { AllergenIncludes } from 'enums/menu';
import { t } from 'state/intl/translations';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';

type ItemAllergensProps = {
  item: ILocalizedMenuEntry;
};

export const ItemAllergens = ({ item }: ItemAllergensProps) => {
  const allergenGroups = useMemo(() => {
    const groupsMap = new Map<AllergenIncludes, string[]>();

    Object.entries(item.nutrition?.allergens || {})
      .filter(([key, value]) => key !== '__typename' && value !== null && value !== '_0')
      .forEach(([key, value]) => {
        const includes = Number((value as string).replace('_', '')) as AllergenIncludes;
        if (!groupsMap.has(includes)) {
          groupsMap.set(includes, []);
        }
        groupsMap.get(includes)!.push(key);
      });

    return Array.from(groupsMap.entries()).map(([allergenIncludes, allergenNames]) => ({
      allergenIncludes,
      allergenNames,
    }));
  }, [item]);

  if (!allergenGroups.length) {
    return null;
  }

  return (
    <>
      <TableHeader testID="allergens-header" title={t('allergenInformation')} />
      <Allergens allergenGroups={allergenGroups} />
    </>
  );
};
